(function () {
  'use strict';

  angular
    .module('vcdrug')
    .config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.drug', {
        url: '/drug',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;drugcurrent patientid="" &gt;</tt></h3><div ui-view="drugcurrent"></div>
              <h3 class="alert alert-info"><tt>&lt;druginteraction patientid="" &gt;</tt></h3><div ui-view="druginteraction"></div>
              <h3 class="alert alert-info"><tt>&lt;drugprescription patientid=""&gt;</tt></h3><div ui-view="drugprescriptionview"></div>
              <h3 class="alert alert-info"><tt>&lt;drugforeign patientid=""&gt;</tt></h3><div ui-view="drugforeignview"></div>
              <h3 class="alert alert-info"><tt>&lt;drughistory patientid=""&gt;</tt></h3><div ui-view="drughistoryview"></div>
              <h3 class="alert alert-info"><tt>&lt;drugactivenumber&gt;</tt></h3><div ui-view="drugactiveview"></div>
              <h3 class="alert alert-info"><tt>&lt;druglist patientid=""&gt;</tt></h3><div ui-view="druglistview"></div>
              <h3 class="alert alert-info"><tt>&lt;drugconfig&gt;</tt></h3><div ui-view="drugconfigview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdrug entered');
        }
      });


    $stateProvider
      .state('playground.drug.allcomponents', {
        url: '/allcomponents',
        resolve: {
          drug: function () {
            return '';
          },
          drugref: function () {
            return '';
          },
          patid: function () {
            return '58499f4c878f751a3eab5019';
          },
          somedrug: function (Drug) {
            return Drug.$find('572b31b07c01597e3e150923');
          },
          alldrugs: function (Drug) {
            return Drug.$search({active: true});
          },
          parentsavesearch: function () {
            return function (drug, drugref) {
              console.log('debug: dummy parentsave called for drugsearch with: ', drug, drugref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'drugcurrent@playground.drug': {
            component: 'drugcurrent',
            bindings: {
              patientid: 'patid'
            }
          },
          'druginteraction@playground.drug': {
            component: 'druginteraction',
            bindings: {
              patientid: 'patid'
            }
          },
          'drughistoryview@playground.drug': {
            component: 'drughistory',
            bindings: {
              patientid: 'patid'
            }
          },
          'drugprescriptionview@playground.drug': {
            component: 'drugprescription',
            bindings: {
              patientid: 'patid'
            }
          },
          'drugforeignview@playground.drug': {
            component: 'drugforeign',
            bindings: {
              patientid: 'patid'
            }
          },
          'drugeditview@playground.drug': {
            component: 'drugeditor',
            bindings: {
              patientid: 'patid'
            }
          },
          'drugactiveview@playground.drug': {
            component: 'numberofactivedrugs',
            bindings: {
              patientid: 'patid'
            }
          },
          'druglistview@playground.drug': {
            component: 'druglist',
            bindings: {
              patientid: 'patid'
            }
          },
          'drugconfigview@playground.drug': {
            component: 'drugconfig'
          }
        },
        onEnter: function () {
          console.log('playground.drug.allcomponents entered');
        }
      });


  }// all routes


}());
